import { injectGlobal } from "emotion";

import { css, keyframes } from "react-emotion";
import styled from "react-emotion";

injectGlobal`

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-touch-callout: none;  
    &:focus {
    outline: none;
    } 
  }



  html, body, button {
    /* width: 100%;
    height: 100vh; */
    max-width: 100%;
    overflow-x: hidden;
    font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva, Verdana, sans-serif;
    /* font-family: 'Quicksand', 'M PLUS Rounded 1c'; */
    font-size: 0.9375rem;
    color: black;
    background: white;
    /* background: rgba(10,20,100,1); */
    /* overflow: hidden; */
  }

  input, textarea {
    -webkit-user-select: text;
    -khtml-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }
`;

// General
export const Container = styled("div")`
  height: 100%;
  width: 100%;
  justify-content: center;
  overflow-x: hidden;
  position: relative;
  padding: 2em;
  text-align: center;
  overflow: scroll;
`;

export const Grid = styled("div")`
  display: grid;
  grid-template-columns: ${(props) => `repeat(${props.columns}, 1fr)`};
  grid-template-rows: auto;
  grid-auto-rows: 1fr;
  grid-auto-flow: row;
  /* height: 100%;
  width: 100%; */
`;

export const GridItem = styled("div")`
  /* position: relative; */
  /* display: flex; */
  cursor: pointer;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 5px;
  margin: ${(props) => (props.margin ? props.margin : "auto")};
  width: ${(props) => (props.width ? props.width : "25em")};
  height: ${(props) => (props.height ? props.height : "15em")};
  background: ${(props) => (props.background ? props.background : "white")};
  color: ${(props) => (props.color ? props.color : "black")};
  box-shadow: ${({ boxShadow }) => boxShadow};
  border: ${({ border }) => border};
`;

export const FlexColumn = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  position: relative;
  justify-content: center;
  height: ${(props) => (props.height ? props.height : "100%")};
  width: ${(props) => (props.width ? props.width : "100%")};
  margin: ${(props) => (props.margin ? props.margin : "auto")};
`;

export const FlexRow = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  position: relative;
  height: ${(props) => (props.height ? props.height : "100%")};
  width: ${(props) => (props.width ? props.width : "100%")};
  margin: ${(props) => (props.margin ? props.margin : 0)};
`;

export const columnFlex = css`
  display: flex;
  flex-direction: column;
`;

export const rowFlex = css`
  display: flex;
  flex-direction: row;
`;

export const FlexCenter = styled("div")`
  display: flex;
  justify-content: center;
`;

export const FlexRight = styled("div")`
  display: flex;
  justify-content: flex-end;
  height: ${(props) => props.height};
`;

export const FlexLeft = styled("div")`
  display: flex;
  justify-content: flex-start;
  height: ${(props) => props.height};
`;

export const flex = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const app = css`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const baseButton = css`
  ${flex};
  border-radius: 0.3rem;
  transition: 0.2s;
  cursor: pointer;
  padding: 0.2rem 1rem;

  &:hover {
    transform: scale3d(1.04, 1.04, 1.04);
    transition: 0.3s;
  }
`;

export const flatWrapper = css`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding: 1rem;
`;

export const contentWrapper = css`
  ${flex};
  position: relative;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

export const container = css`
  height: 100%;
  overflow-y: scroll;
  /* overflow: scroll !important; */

  ::-webkit-scrollbar {
    width: 0px; /* remove scrollbar space */
    background: transparent; /* optional: just make scrollbar invisible */
  }

  @media (max-width: 450px) {
    overflow-y: hidden;
  }
`;

export const webContainer = css`
  max-width: 1400px;
  margin: auto;
  width: 1000px;

  ::-webkit-scrollbar {
    width: 0px; /* remove scrollbar space */
    background: transparent; /* optional: just make scrollbar invisible */
  }

  @media (max-width: 450px) {
    overflow-y: hidden;
  }
`;

// BackGround Wrapper
export const BlueBackGround = styled("div")`
  display: flex;
  text-align: center;
  color: black;
  padding: 1em;
  justify-content: flex-start;
`;

// Components
export const BottomHintText = styled("span")`
  color: grey;
  font-size: 0.8em;
`;

export const Modal = styled("div")`
  position: fixed;
  left: ${(props) => (props.left ? props.left : "50%")};
  top: ${(props) => (props.top ? props.top : "50%")};
  transform: ${(props) =>
    props.transform ? props.transform : "translate(-50%, -50%)"};
  background: white;
  z-index: 999;
  overflow-y: ${(props) => props.overFlowY};
  padding: ${(props) => (props.padding ? props.padding : "2em")};
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  display: ${(props) => (props.hidden ? "block" : "none")};

  ::-webkit-scrollbar {
    width: 0px; /* remove scrollbar space */
    background: transparent; /* optional: just make scrollbar invisible */
  }
`;

export const ModalHeader = styled("div")`
  margin: 1em;
`;

export const FormContainer = styled("div")`
  z-index: 2;
  position: ${({ position }) => position};
  margin: 0px 40px;
  width: ${(props) => (props.width ? props.width : "100%")};
  top: ${(props) => (props.top ? props.top : 0)};
  left: ${(props) => (props.left ? props.left : 0)};
`;

export const Form = styled("div")`
  position: relative;
  width: ${({ width }) => width};
  padding: ${(props) => (props.padding ? props.padding : "1em")};
  border-radius: 5px;
  margin-bottom: ${(props) => props.marginBottom};
  margin-top: ${(props) => props.marginTop};
  background: ${(props) => (props.background ? props.background : "white")};
  display: ${(props) => (props.hidden ? "none" : "default")};
  box-shadow: rgb(120 120 120 / 50%) 3px 3px 13px;
  /* border: 1px solid #c2baba; */
`;

export const H1 = styled("h1")`
  color: ${(props) => (props.color ? props.color : "#1F3747")};
  float: ${(props) => (props.float ? props.float : "default")};
  margin: ${(props) => (props.margin ? props.margin : "auto")};
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "inherit")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "default")};
  text-align: ${(props) => props.textAlign};
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "inherit")};
  text-align: center;
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
`;

export const H2 = styled("h2")`
  color: ${(props) => (props.color ? props.color : "#1F3747")};
  float: ${(props) => (props.float ? props.float : "default")};
  margin: ${(props) => (props.margin ? props.margin : "auto")};
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "inherit")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "default")};
  text-align: ${(props) => props.textAlign};
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "inherit")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "inherit")};
`;

export const P = styled("p")`
  color: ${(props) => (props.color ? props.color : "#1F3747")};
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "inherit")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "1em")};
  margin-top: ${(props) => props.marginTop};
  margin: ${(props) => props.margin};
  word-wrap: break-word;
  position: relative;
  width: ${(props) => props.width};
`;

export const Label = styled("label")`
  width: 220px;
  display: ${(props) => (props.title ? "block" : "none")};
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 0.9375rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;

export const LineButton = styled("div")`
  text-decoration: underline;
  cursor: pointer;
  right: 0;
  margin: ${(props) => props.margin};
  width: ${(props) => props.width};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "default")};
  color: ${(props) => (props.color ? props.color : "#1F3747")};
  line-height: ${(props) => props.lineHeight};
  font-family: ${(props) => props.fontFamily};
`;

export const Button = styled("div")`
  border-radius: 5px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  display: flex;
  justify-content: center;
  user-select: none;
  box-shadow: 3px 3px 13px rgb(120 120 120 / 50%);
  cursor: ${(props) => props.cursor || "pointer"};
  pointer-events: ${(props) => props.disabled && "none"};
  color: ${(props) => props.color || "white"};
  margin: ${(props) => props.margin || "10px"};
  font-weight: bold;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  padding: ${(props) => (props.padding ? props.padding : "10px")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "100%")};
  background: ${(props) => {
    const { background, disabled } = props;

    if (disabled) return "#adadad";

    return background || "#89d2d3";
  }};
  transform: ${(props) => (props.scale ? `scale(${props.scale})` : "none")};
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : "inherit")};

  a {
    text-decoration: none;
    color: white;
  }
`;

export const Select = styled("select")`
  border: 1px solid #5ba8a7;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

export const Hr = styled("hr")`
  border: 1px solid rgb(218, 218, 218);
  margin: 20px 0px;
`;

export const VerticalLineBreak = styled("div")`
  height: ${(props) => props.height};
  border-left: 4px solid ${(props) => props.color};
  margin: ${(props) => props.margin};
`;

export const Image = styled("img")`
  display: inline-block;
  height: auto;
  background-size: cover;
  border-radius: ${(props) =>
    props.borderRadius ? props.borderRadius : ".4rem"};
  cursor: ${(props) => (props.cursor ? props.cursor : "default")};
  width: ${(props) => (props.width ? props.width : "5rem")};
  height: ${(props) => (props.height ? props.height : "auto")};
  box-shadow: rgba(120, 120, 120, 0.5) 3px 3px 13px;
`;

export const ImageUploadButton = styled("div")`
  background: #1f3747;
  color: white;
  padding: 10 5 10 5;
  text-align: center;
  width: 11em;
  height: 30px;
  border-radius: 5px;
  font-size: 10px;
  font-weight: bold;
  cursor: pointer;
`;

export const SmallModal = styled("div")`
  position: absolute;
  z-index: 10;
  background: white;
  border-radius: 5px;
  padding: 10px;
  flex-direction: row;
  justify-content: center;
  border: ${(props) =>
    props.border ? props.border : "3px solid rgb(190, 226, 226)"};
  width: ${(props) => (props.width ? props.width : "225px")};
  height: ${(props) => (props.height ? props.height : "100px")};
  left: ${(props) => (props.left ? props.left : "60px")};
  right: ${(props) => (props.right ? props.right : "auto")};
  top: ${(props) => (props.top ? props.top : "30px")};
  display: ${(props) => (props.hidden ? "none" : "flex")};
`;

export const TextModal = styled("div")`
  position: absolute;
  z-index: 10;
  background: white;
  color: black;
  border: 1px solid #000000;
  bottom: 0;
  left: ${(props) => props.left};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  display: ${(props) => (props.show ? "block" : "none")};
`;

// AppView
export const AppView = styled("div")`
  width: 25em;
  height: 96vh;
  left: ${(props) => (props.left ? props.left : "57%")};
  border-radius: 15px;
  max-height: 750px;
  /* border: 1.5px solid; */
  box-shadow: rgb(120 120 120 / 50%) 6px 6px 13px;
  /* overflow: hidden; */
  position: ${(props) => (props.position ? props.position : "fixed")};
  top: ${(props) => (props.top ? props.top : "5em")};
  margin: ${(props) => (props.margin ? props.margin : "2em")};
  transform: ${(props) => (props.scale ? `scale(${props.scale})` : "none")};
`;

// export const SmartPhoneView = styled("div")`
//   position: relative;
//   width: 360px;
//   height: 640px;
//   margin: auto;
//   border: 16px black solid;
//   border-top-width: 60px;
//   border-bottom-width: 60px;
//   border-radius: 36px;

//   /* The horizontal line on the top of the device */
//   ::before {
//     content: "";
//     display: block;
//     width: 60px;
//     height: 5px;
//     position: absolute;
//     top: -30px;
//     left: 50%;
//     transform: translate(-50%, -50%);
//     background: #333;
//     border-radius: 10px;
//   }

//   /* The circle on the bottom of the device */
//   ::after {
//     content: "";
//     display: block;
//     width: 35px;
//     height: 35px;
//     position: absolute;
//     left: 50%;
//     bottom: -65px;
//     transform: translate(-50%, -50%);
//     background: #333;
//     border-radius: 50%;
//   }
// `;

// export const SmartPhoneContent = styled("div")`
//   width: 360px;
//   height: 640px;
//   background: white;
// `;
